export default __webpack_public_path__ + "static/media/avatar_cheshire_cat6.e543113d.mp3";